<template lang="html">
  <div class="sidebar_menu">
    <div class="menu_link">
      <img
        :src="require('@/assets/scoutMenu.svg')"
        class="menu_icon_img"
        alt=""
      />
      <span class="menu_title">{{ $t("Scout") }}</span>
    </div>
    <div class="projectListMenu">
      <div class="projectListItem">
        <div class="submenu_link withToggler">
          <span
            class="small_menu_title level_1"
            @click="toggleLinkplus = !toggleLinkplus"
            >{{ $t("My Scouting with Link+") }}</span
          >
          <img
            :src="require('@/assets/open.svg')"
            @click="toggleLinkplus = true"
            alt=""
            v-if="toggleLinkplus == false"
          />
          <img
            :src="require('@/assets/close.svg')"
            @click="toggleLinkplus = false"
            alt=""
            v-if="toggleLinkplus == true"
          />
        </div>
      </div>

      <div class="projectListSubMenu" v-if="toggleLinkplus == true">
        <div class="projectListItem">
          <router-link to="/link_plus" class="submenu_link">
            <span class="small_menu_title">{{ $t("Create") }}</span>
          </router-link>
        </div>
        <div class="projectListItem">
          <router-link to="/list_link_plus" class="submenu_link">
            <span class="small_menu_title">{{ $t("Manage") }}</span>
          </router-link>
        </div>
      </div>

      <router-link to="/startups_ecosystem" class="submenu_link">
        <span class="small_menu_title level_1">{{
          $t("My innovator pool")
        }}</span>
      </router-link>

      <router-link to="/rankings" class="submenu_link">
        <span class="small_menu_title level_1">{{ $t("My Priorities") }}</span>
      </router-link>

      <router-link to="/my_shared_lists" class="submenu_link">
        <span class="small_menu_title level_1">{{ $t("My shared lists") }}</span>
      </router-link>
    </div>

    <a
      href="https://outlook.office365.com/owa/calendar/innopearl@innopearl.ch/bookings/"
      target="_blank"
      class="menu_link"
    >
      <img
        :src="require('@/assets/askMenu.svg')"
        class="menu_icon_img"
        alt=""
      />
      <span class="menu_title">{{ $t("Ask us") }}</span>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MenuSidebar",
  props: ["addAccount"],
  components: {},
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      activeProject: null,
      activelink: null,
      toggleProject: false,
      toggleLinkplus: false,
      toggleAssessment: false,
      toogleAdminPan: false,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.activeProject = this.$route.params.id;
    } else if (this.$route.params.projectid) {
      this.activeProject = this.$route.params.projectid;
    } else if (this.$route.params.pid) {
      this.activeProject = this.$route.params.pid;
      this.activelink = this.$route.params.id;
    } else if (this.$route.params.lid) {
      this.activelink = this.$route.params.id;
    } else {
      this.activeProject = null;
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.params);
      if (to.params.id) {
        this.activeProject = to.params.id;
        this.activelink = this.$route.params.id;
      } else if (to.params.projectid) {
        this.activeProject = to.params.projectid;
      } else if (to.params.pid) {
        this.activeProject = to.params.pid;
      } else if (to.params.lid) {
        this.activelink = to.params.lid;
      } else {
        this.activeProject = null;
      }
      console.log(from);
    },
  },
  computed: mapState(["role", "fullname", "myProjects", "myLinksPlus"]),
};
</script>

<style lang="css" scoped>
.sidebar_menu {
  display: flex;
  flex-direction: column;
}

.menu_link {
  border: 1px solid #3783c5;
  border-radius: 200px;
  padding: 8px 15px;
  color: #3783c5;
  align-items: center;
  display: flex;
  gap: 20px;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0px;
  text-transform: uppercase;
  text-decoration: none;
  margin-bottom: 10px;
  margin-top: 50px;
}
.menu_link:first-child {
  margin-top: 10px;
}
.menu_item {
  padding-bottom: 10px;
  border-bottom: 1px solid #c2c4c6;
}

.projectListMenu {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.projectListSubMenu {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.submenu_link {
  display: flex;
  margin-left: 10px;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #000000;
  text-decoration: none;
  font-weight: 300;
}

.menu_icon_img {
  width: 30px !important;
  height: 35px !important;
  object-fit: contain;
}

.account_responsive {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0px;
  color: #3783c5;
  text-transform: uppercase;
  text-decoration: none;
  margin-top: 20px;
}
.account_responsive img {
  width: 30px;
}
@media screen and (min-width: 1200px) {
  .account_responsive {
    display: none;
  }
}

.active_link_by_project,
.active_link_by_project * {
  color: #3783c5 !important;
  font-weight: bold;
}
.logoImage {
  width: 50px !important;
  height: 50px;
  object-fit: contain;
  border-radius: 50%;
}

.menu_title {
  color: #3783c5;
  font-size: 14px;
  font-weight: 500;
}
.small_menu_title {
  font-size: 14px;
}
.small_menu_title.level_1 {
  color: #000;
  font-weight: 500;
  text-transform: uppercase;
}
.menuDivider {
  width: 100%;
  height: 1px;
  background: #c2c4c6;
  margin-top: 30px;
  margin-bottom: 30px;
}

.withToggler {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.mainMenuLink {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
